<div class="input-group position-relative">
  <input
    #companyInput
    type="text"
    class="form-control"
    [ngbTypeahead]="search"
    [resultFormatter]="formatter"
    [inputFormatter]="formatter"
    [editable]="false"
    [(ngModel)]="selectedCompany"
    (selectItem)="onSelect($event.item)"
    (input)="onInput()"
    (blur)="onBlur()"
    placeholder="Cerca azienda B2B..."
  />
  <i *ngIf="selectedCompany" class="bi bi-x-lg position-absolute pointer" style="right: 12px; top: 9px; color: black;" (click)="clearSelection()"></i>
</div>
